(function () {
  'use strict';

  function initBridalSurvey(section) {
    if (!section || section.dataset.bridalInitialized === 'true') {
      return;
    }

    section.dataset.bridalInitialized = 'true';

    const form = section.querySelector('[data-bridal-form]');

    const questions = Array.from(
      section.querySelectorAll('[data-question]')
    );

    const previousButton = section.querySelector('[data-previous]');

    const currentQuestionElement = section.querySelector(
      '[data-current-question]'
    );

    const progressPercentElement = section.querySelector(
      '[data-progress-percent]'
    );

    const progressBar = section.querySelector(
      '[data-progress-bar]'
    );

    const progress = section.querySelector(
      '.bridal-survey__progress'
    );

    const progressWrapper = section.querySelector(
      '.bridal-survey__progress-wrapper'
    );

    const surveyHeader = section.querySelector(
      '.bridal-survey__header'
    );

    const resultScreen = section.querySelector(
      '[data-result-screen]'
    );

    const resultTitle = section.querySelector(
      '[data-result-title]'
    );
    const resultEyebrow = section.querySelector(
    '[data-result-eyebrow]'
    );
    const resultImage = section.querySelector(
      '[data-result-image]'
    );

    const resultLink = section.querySelector(
      '[data-result-link]'
    );

    const resultButton = section.querySelector(
      '[data-result-button]'
    );
    const restartButton = section.querySelector(
      '[data-restart-survey]'
    );

    if (!form || !questions.length) {
      return;
    }

    /*
     * Çerez ayarları
     *
     * Çerez 24 saat boyunca geçerlidir.
     * Aynı alan adındaki tüm sayfalarda çalışır.
     */
    const BRIDAL_COOKIE_NAME = 'hof_bridal_survey';
    const BRIDAL_COOKIE_HOURS = 24;

    let currentQuestion = 1;
    let isTransitioning = false;

    const answers = {
      question_1: '',
      question_2: '',
      question_3: '',
      question_4: '',
      question_5: '',
      question_6: '',
      question_7: '',
      question_8: '',
      question_9: '',
      question_10: ''
    };

    /*
     * Türkçe karakterleri güvenli biçimde Base64'e çevirir.
     *
     * Bu yöntem çerez boyutunu azaltır ve Türkçe karakterlerin
     * çerez içinde bozulmasını önler.
     */
    function encodeCookieValue(value) {
      try {
        const bytes = new TextEncoder().encode(value);

        let binary = '';

        bytes.forEach(function (byte) {
          binary += String.fromCharCode(byte);
        });

        return window.btoa(binary);
      } catch (error) {
        return encodeURIComponent(value);
      }
    }

    /*
     * Base64 çerez değerini tekrar normal metne çevirir.
     */
    function decodeCookieValue(value) {
      try {
        const binary = window.atob(value);
        const bytes = new Uint8Array(binary.length);

        for (let index = 0; index < binary.length; index += 1) {
          bytes[index] = binary.charCodeAt(index);
        }

        return new TextDecoder().decode(bytes);
      } catch (error) {
        return decodeURIComponent(value);
      }
    }

    /*
     * Belirtilen saat boyunca geçerli çerez oluşturur.
     */
    function setCookie(name, value, hours) {
      const expires = new Date();

      expires.setTime(
        expires.getTime() + hours * 60 * 60 * 1000
      );

      let cookie =
        encodeURIComponent(name) +
        '=' +
        encodeCookieValue(value) +
        '; expires=' +
        expires.toUTCString() +
        '; path=/' +
        '; SameSite=Lax';

      if (window.location.protocol === 'https:') {
        cookie += '; Secure';
      }

      document.cookie = cookie;
    }

    /*
     * Kaydedilmiş çerezi okur.
     */
    function getCookie(name) {
      const cookieName = encodeURIComponent(name) + '=';
      const cookies = document.cookie.split(';');

      for (let index = 0; index < cookies.length; index += 1) {
        const cookie = cookies[index].trim();

        if (cookie.indexOf(cookieName) === 0) {
          const value = cookie.substring(cookieName.length);

          return decodeCookieValue(value);
        }
      }

      return null;
    }

    /*
     * Geçersiz veya bozuk çerezi siler.
     */
    function deleteCookie(name) {
      let cookie =
        encodeURIComponent(name) +
        '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
        '; path=/' +
        '; SameSite=Lax';

      if (window.location.protocol === 'https:') {
        cookie += '; Secure';
      }

      document.cookie = cookie;
    }

    function getQuestion(number) {
      return section.querySelector(
        '[data-question="' + number + '"]'
      );
    }

    function updateProgress() {
      const percentage = Math.round(
        (currentQuestion / questions.length) * 100
      );

      if (currentQuestionElement) {
        currentQuestionElement.textContent = currentQuestion;
      }

      if (progressPercentElement) {
        progressPercentElement.textContent = percentage + '%';
      }

      if (progressBar) {
        progressBar.style.width = percentage + '%';
      }

      if (progress) {
        progress.setAttribute(
          'aria-valuenow',
          String(currentQuestion)
        );
      }

      if (previousButton) {
        previousButton.hidden = currentQuestion === 1;
      }
    }

    function focusCurrentQuestion() {
      const activeQuestion = getQuestion(currentQuestion);

      if (!activeQuestion) {
        return;
      }

      const textarea = activeQuestion.querySelector(
        '[data-text-answer]'
      );

      if (!textarea) {
        return;
      }

      window.setTimeout(function () {
        try {
          textarea.focus({
            preventScroll: true
          });
        } catch (error) {
          textarea.focus();
        }
      }, 250);
    }

    function scrollToSurvey() {
      const headerOffset = 110;

      const targetTop =
        section.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset;

      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: 'smooth'
      });
    }

    function showQuestion(number, shouldScroll) {
      if (number < 1 || number > questions.length) {
        return;
      }

      /*
       * Sonuç ekranından soru ekranına dönülmesi gerekirse
       * normal survey alanlarını tekrar görünür yapar.
       */
      if (resultScreen) {
        resultScreen.hidden = true;
        resultScreen.classList.remove('is-visible');
      }

      if (surveyHeader) {
        surveyHeader.hidden = false;
      }

      if (progressWrapper) {
        progressWrapper.hidden = false;
      }

      form.classList.remove('is-complete');

      questions.forEach(function (question) {
        question.hidden = true;
        question.classList.remove('is-active');
      });

      const targetQuestion = getQuestion(number);

      if (!targetQuestion) {
        return;
      }

      currentQuestion = number;
      targetQuestion.hidden = false;

      window.requestAnimationFrame(function () {
        targetQuestion.classList.add('is-active');
      });

      updateProgress();
      focusCurrentQuestion();

      if (shouldScroll !== false) {
        scrollToSurvey();
      }
    }

    function getResultData() {
  const firstAnswer = answers.question_1;

  if (firstAnswer === 'A') {
    return {
      key: 'A',
      title: "Sen bir Retro Bride\u2019sın.",
      eyebrow:
        'Nostaljiyi romantize ediyorsun. Vintage dokular seni anlatıyor.',
      buttonText: 'Retro Bride koleksiyonunu keşfet',
      url:
        section.dataset.resultAUrl ||
        '/collections/retro-bride',
      image:
        section.dataset.resultAImage ||
        'https://cdn.shopify.com/s/files/1/0627/7955/6010/files/retro.jpg?v=1784658663'
    };
  }

  if (firstAnswer === 'B') {
    return {
      key: 'B',
      title: "Sen bir Anti Bride\u2019sın.",
      eyebrow:
        'Kural tanımıyorsun sanırım. Kim seni tutabilir?',
      buttonText: 'Anti Bride koleksiyonunu keşfet',
      url:
        section.dataset.resultBUrl ||
        '/collections/anti-bride',
      image:
        section.dataset.resultBImage ||
        'https://cdn.shopify.com/s/files/1/0627/7955/6010/files/anti.jpg?v=1784658663'
    };
  }

  if (firstAnswer === 'C') {
    return {
      key: 'C',
      title: "Sen bir Angelic Bride\u2019sın.",
       eyebrow:
        'Modernsin, sadesin ve bir o kadar şıksın. Az, senin için her zaman daha çok.',
      buttonText: 'Angelic Bride koleksiyonunu keşfet',
      url:
        section.dataset.resultCUrl ||
        '/collections/angelic-bride',
      image:
        section.dataset.resultCImage ||
        'https://cdn.shopify.com/s/files/1/0627/7955/6010/files/angelic.jpg?v=1784658663'
    };
  }

  return null;
}

    /*
     * Survey durumunu 24 saatlik çereze kaydeder.
     *
     * completed:
     * true  → Survey tamamlandı, sonuç ekranı gösterilecek.
     * false → Survey yarıda bırakıldı, kaldığı sorudan devam edecek.
     */
    function storeSurveyAnswers(completed, nextQuestion) {
      try {
        const savedQuestion = Math.min(
          Math.max(Number(nextQuestion) || currentQuestion, 1),
          questions.length
        );

        /*
         * Çerez boyutunu düşük tutmak için kısa alan adları kullanıyoruz:
         *
         * s  = survey
         * u  = updated timestamp
         * c  = completed
         * r  = result
         * q  = current/next question
         * a  = answers
         */
        const payload = {
          s: 'bridal',
          u: Date.now(),
          c: Boolean(completed),
          r: answers.question_1 || '',
          q: savedQuestion,
          a: {
            1: answers.question_1,
            2: answers.question_2,
            3: answers.question_3,
            4: answers.question_4,
            5: answers.question_5,
            6: answers.question_6,
            7: answers.question_7,
            8: answers.question_8,
            9: answers.question_9,
            10: answers.question_10
          }
        };

        setCookie(
          BRIDAL_COOKIE_NAME,
          JSON.stringify(payload),
          BRIDAL_COOKIE_HOURS
        );
      } catch (error) {
        console.warn(
          'Bridal survey cevapları çereze kaydedilemedi.',
          error
        );
      }
    }

    /*
     * Kaydedilen cevapları form alanlarına geri yerleştirir.
     */
    function populateSavedAnswers() {
      section
        .querySelectorAll('[data-answer]')
        .forEach(function (input) {
          const questionElement = input.closest(
            '[data-question]'
          );

          if (!questionElement) {
            return;
          }

          const questionNumber =
            questionElement.dataset.question;

          const savedValue =
            answers['question_' + questionNumber];

          input.checked = input.value === savedValue;
        });

      section
        .querySelectorAll('[data-text-answer]')
        .forEach(function (textarea) {
          const questionElement = textarea.closest(
            '[data-question]'
          );

          if (!questionElement) {
            return;
          }

          const questionNumber =
            questionElement.dataset.question;

          const savedValue =
            answers['question_' + questionNumber] || '';

          textarea.value = savedValue;

          const countElement = questionElement.querySelector(
            '[data-character-count]'
          );

          if (countElement) {
            countElement.textContent = savedValue.length;
          }
        });
    }

    /*
     * Sonuç ekranını oluşturur.
     *
     * shouldScroll false olduğunda sayfa yeniden ziyaret edildiğinde
     * otomatik scroll hareketi yapılmaz.
     */
    function displayResult(result, shouldScroll) {
      questions.forEach(function (question) {
        question.hidden = true;
        question.classList.remove('is-active');
      });

      if (progressWrapper) {
        progressWrapper.hidden = true;
      }

      if (surveyHeader) {
        surveyHeader.hidden = true;
      }

      if (previousButton) {
        previousButton.hidden = true;
      }
if (resultEyebrow) {
  resultEyebrow.textContent = result.eyebrow;
}
      if (resultTitle) {
        resultTitle.textContent = result.title;
      }

      if (resultImage) {
        resultImage.src = result.image;
        resultImage.alt = result.title;
      }

      if (resultLink) {
        resultLink.href = result.url;

        resultLink.setAttribute(
          'aria-label',
          result.buttonText
        );
      }

      if (resultButton) {
        resultButton.href = result.url;
        resultButton.textContent = result.buttonText;
      }

      if (resultScreen) {
        resultScreen.hidden = false;
      }

      form.classList.add('is-complete');

      window.requestAnimationFrame(function () {
        if (resultScreen) {
          resultScreen.classList.add('is-visible');
        }
      });

      if (shouldScroll !== false) {
        scrollToSurvey();
      }
    }
function resetSurvey() {
  /*
   * Kaydedilmiş 24 saatlik çerezi siler.
   */
  deleteCookie(BRIDAL_COOKIE_NAME);

  /*
   * JavaScript içindeki cevapları temizler.
   */
  Object.keys(answers).forEach(function (key) {
    answers[key] = '';
  });

  /*
   * Tüm görsel/radio seçimlerini kaldırır.
   */
  section
    .querySelectorAll('[data-answer]')
    .forEach(function (input) {
      input.checked = false;
    });

  /*
   * Metin cevaplarını ve karakter sayaçlarını temizler.
   */
  section
    .querySelectorAll('[data-text-answer]')
    .forEach(function (textarea) {
      textarea.value = '';
      textarea.removeAttribute('aria-invalid');

      const questionElement = textarea.closest(
        '[data-question]'
      );

      if (!questionElement) {
        return;
      }

      const countElement = questionElement.querySelector(
        '[data-character-count]'
      );

      const errorElement = questionElement.querySelector(
        '[data-error]'
      );

      if (countElement) {
        countElement.textContent = '0';
      }

      if (errorElement) {
        errorElement.hidden = true;
      }
    });

  /*
   * Sonuç ekranı içeriğini temizler.
   */
  if (resultScreen) {
    resultScreen.hidden = true;
    resultScreen.classList.remove('is-visible');
  }

  if (resultTitle) {
    resultTitle.textContent = '';
  }

  if (resultImage) {
    resultImage.removeAttribute('src');
    resultImage.alt = '';
  }

  if (resultLink) {
    resultLink.href = '#';
    resultLink.removeAttribute('aria-label');
  }

  if (resultButton) {
    resultButton.href = '#';
  }

  /*
   * Formu yeniden aktif hale getirir.
   */
  form.classList.remove('is-complete');

  currentQuestion = 1;
  isTransitioning = false;

  showQuestion(1, true);
}
    function finishSurvey() {
      if (!answers.question_1) {
        showQuestion(1, true);
        return;
      }

      const result = getResultData();

      if (!result) {
        console.error(
          'Bridal survey sonucu oluşturulamadı.'
        );

        return;
      }

      /*
       * Survey tamamlandı olarak 24 saatlik çereze kaydedilir.
       */
      storeSurveyAnswers(true, questions.length);

      displayResult(result, true);
    }

    /*
     * Sayfa açıldığında 24 saatlik çerezi kontrol eder.
     */
    function restoreSurveyFromCookie() {
      const storedCookie = getCookie(BRIDAL_COOKIE_NAME);

      if (!storedCookie) {
        return false;
      }

      try {
        const storedData = JSON.parse(storedCookie);

        if (
          !storedData ||
          storedData.s !== 'bridal' ||
          !storedData.a
        ) {
          deleteCookie(BRIDAL_COOKIE_NAME);
          return false;
        }

        /*
         * Çerez süresi tarayıcı tarafından zaten kontrol edilir.
         * Buna ek olarak JavaScript tarafında da 24 saat kontrolü yapılır.
         */
        const storedTime = Number(storedData.u);
        const maximumAge =
          BRIDAL_COOKIE_HOURS * 60 * 60 * 1000;

        if (
          !storedTime ||
          Date.now() - storedTime > maximumAge
        ) {
          deleteCookie(BRIDAL_COOKIE_NAME);
          return false;
        }

        Object.keys(answers).forEach(function (key) {
          const questionNumber = key.replace(
            'question_',
            ''
          );

          const savedAnswer =
            storedData.a[questionNumber];

          if (
            typeof savedAnswer === 'string'
          ) {
            answers[key] = savedAnswer;
          }
        });

        populateSavedAnswers();

        /*
         * Survey daha önce tamamlandıysa direkt sonuç ekranı gösterilir.
         */
        if (
          storedData.c === true &&
          answers.question_1
        ) {
          const result = getResultData();

          if (result) {
            displayResult(result, false);
            return true;
          }
        }

        /*
         * Survey yarıda bırakıldıysa kayıtlı sorudan devam edilir.
         */
        const savedQuestion = Number(storedData.q);

        if (
          Number.isInteger(savedQuestion) &&
          savedQuestion >= 1 &&
          savedQuestion <= questions.length
        ) {
          showQuestion(savedQuestion, false);
          return true;
        }

        showQuestion(1, false);

        return true;
      } catch (error) {
        console.warn(
          'Bridal survey çerezi okunamadı.',
          error
        );

        deleteCookie(BRIDAL_COOKIE_NAME);

        return false;
      }
    }

    function goToNextQuestion() {
      if (isTransitioning) {
        return;
      }

      if (currentQuestion >= questions.length) {
        finishSurvey();
        return;
      }

      isTransitioning = true;

      window.setTimeout(function () {
        showQuestion(currentQuestion + 1, true);

        window.setTimeout(function () {
          isTransitioning = false;
        }, 300);
      }, 160);
    }

    function saveChoice(input) {
      const questionElement = input.closest(
        '[data-question]'
      );

      if (!questionElement) {
        return;
      }

      const questionNumber =
        questionElement.dataset.question;

      answers['question_' + questionNumber] =
        input.value;

      /*
       * Kullanıcı son sorudaysa tamamlanma işlemini
       * finishSurvey yapacak.
       *
       * Diğer sorularda bir sonraki soru kayıt altına alınır.
       */
      if (currentQuestion < questions.length) {
        storeSurveyAnswers(
          false,
          currentQuestion + 1
        );
      }

      goToNextQuestion();
    }

    function saveTextAnswer(questionElement) {
      const textarea = questionElement.querySelector(
        '[data-text-answer]'
      );

      const errorElement = questionElement.querySelector(
        '[data-error]'
      );

      if (!textarea) {
        return false;
      }

      const value = textarea.value.trim();

      if (!value) {
        if (errorElement) {
          errorElement.hidden = false;
        }

        textarea.setAttribute(
          'aria-invalid',
          'true'
        );

        textarea.focus();

        return false;
      }

      if (errorElement) {
        errorElement.hidden = true;
      }

      textarea.removeAttribute('aria-invalid');

      const questionNumber =
        questionElement.dataset.question;

      answers['question_' + questionNumber] = value;

      if (currentQuestion < questions.length) {
        storeSurveyAnswers(
          false,
          currentQuestion + 1
        );
      }

      return true;
    }

    section
      .querySelectorAll('[data-answer]')
      .forEach(function (input) {
        input.addEventListener(
          'change',
          function () {
            saveChoice(input);
          }
        );
      });

    section
      .querySelectorAll('[data-next-text]')
      .forEach(function (button) {
        button.addEventListener(
          'click',
          function () {
            const questionElement = button.closest(
              '[data-question]'
            );

            if (
              questionElement &&
              saveTextAnswer(questionElement)
            ) {
              goToNextQuestion();
            }
          }
        );
      });

    section
      .querySelectorAll('[data-text-answer]')
      .forEach(function (textarea) {
        const questionElement = textarea.closest(
          '[data-question]'
        );

        const countElement = questionElement
          ? questionElement.querySelector(
              '[data-character-count]'
            )
          : null;

        const errorElement = questionElement
          ? questionElement.querySelector(
              '[data-error]'
            )
          : null;

        textarea.addEventListener(
          'input',
          function () {
            if (countElement) {
              countElement.textContent =
                textarea.value.length;
            }

            if (textarea.value.trim()) {
              textarea.removeAttribute(
                'aria-invalid'
              );

              if (errorElement) {
                errorElement.hidden = true;
              }
            }
          }
        );

        textarea.addEventListener(
          'keydown',
          function (event) {
            if (
              event.key === 'Enter' &&
              (event.ctrlKey || event.metaKey)
            ) {
              event.preventDefault();

              if (
                questionElement &&
                saveTextAnswer(questionElement)
              ) {
                goToNextQuestion();
              }
            }
          }
        );
      });

    if (previousButton) {
      previousButton.addEventListener(
        'click',
        function () {
          if (currentQuestion > 1) {
            const previousQuestion =
              currentQuestion - 1;

            showQuestion(previousQuestion, true);

            /*
             * Geri gidilen soru da çereze kaydedilir.
             */
            storeSurveyAnswers(
              false,
              previousQuestion
            );
          }
        }
      );
    }
    if (restartButton) {
  restartButton.addEventListener(
    'click',
    function () {
      resetSurvey();
    }
  );
}

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
      }
    );

    /*
     * Sayfa ilk açıldığında önce çerez kontrol edilir.
     *
     * Çerez bulunamazsa anket normal şekilde ilk sorudan başlar.
     */
    const surveyRestored =
      restoreSurveyFromCookie();

    if (!surveyRestored) {
      showQuestion(1, false);
    }
  }

  function initAllBridalSurveys(scope) {
    const currentScope = scope || document;

    if (
      currentScope.matches &&
      currentScope.matches(
        '[data-bridal-survey]'
      )
    ) {
      initBridalSurvey(currentScope);
    }

    currentScope
      .querySelectorAll('[data-bridal-survey]')
      .forEach(function (section) {
        initBridalSurvey(section);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllBridalSurveys(document);
      }
    );
  } else {
    initAllBridalSurveys(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllBridalSurveys(event.target);
    }
  );
})();